import gql from 'graphql-tag';
export const MarkCommentsReadMutation = gql`
	mutation MarkInlineCommentsReadMutation($commentIds: [ID!]!) {
		markCommentsAsRead(input: { commentIds: $commentIds }) {
			success
			errors
		}
	}
`;
